import { createAction, props } from '@ngrx/store';
import { DisclosureLogin } from '../../interfaces/disclosure-login';

//Disclosure login filter
//For login page and edit Personal info modal
//disclosures/filter
export const loadDisclosureLogin = createAction(
    '[DisclosureLogin] Load Disclosure Login',
    props<{ disclosureName: string }>()
);

export const loadDisclosureLoginSuccess = createAction(
    '[DisclosureLogin] Load Disclosure Login Success',
    props<DisclosureLogin>()
);

export const loadDisclosureLoginFailure = createAction(
    '[DisclosureLogin] Load Disclosure Login Failure',
    props<String>()
);
///////////////

//Disclosure Login Success
//For login page and edit Personal info modal
/// /disclosures
export const postDisclosureLogin = createAction(
    '[Disclosure Login] Post Disclosure Login',
    props<{ disclosureName: string; phoneNumber: string }>()
    // props<{ disclosureName: string; roseKey: string; attributes: { name: string, value: string}}>
);

export const postDisclosureLoginSuccess = createAction(
    '[DisclosureLogin] Post Disclosure Login Success'
 );
 export const postDisclosureLoginFailure = createAction(
     '[DisclosureLogin] Post Disclosure Login Failure',
     props<{ error: string }>()
 );


//Disclosure actions for edit Bank info modal
//New actios to get the disclosure on Bank info modal
 export const loadBankDisclosure = createAction(
    '[Bank Disclosure] Load Bank Disclosure',
    props<{ disclosureName: string; returnType: string; attributes: { name: string; value: string }[] }>()
);

export const loadBankDisclosureSuccess = createAction(
    '[Bank Disclosure] Load Bank Disclosure Success',
    props<{ disclosureContent: string; contentType: string; disclosureVersion: number }>()
);

export const loadBankDisclosureFailure = createAction(
    '[Bank Disclosure] Load Bank Disclosure Failure',
    props<{ error: string }>()
);

// New action to set the disclosure on SF
export const postBankDisclosure = createAction(
    '[Bank Disclosure] Post Bank Disclosure',
    props<{ roseKey: string; disclosureName: string; attributes: { name: string; value: string }[] }>()
);

export const postBankDisclosureSuccess = createAction(
    '[Bank Disclosure] Post Bank Disclosure Success'
);

export const postBankDisclosureFailure = createAction(
    '[Bank Disclosure] Post Bank Disclosure Failure',
    props<{ error: string }>()
);


//Action to clear the disclosure content
export const clearDisclosureContent = createAction('[Disclosure] Clear Disclosure Content');


//Action for the pdf disclosure content download
export const downloadBankDisclosureContent = createAction(
    '[Disclosure] Download Bank Disclosure Content',
    props<{disclosureName: string; returnType: string; attributes: any[]}>()
);
